// extracted by mini-css-extract-plugin
export default {"mobileHeight":"screen and (max-height: 824px)","header":"StepHeaderNavSection_header__c2ceR","hidden":"StepHeaderNavSection_hidden__z2P92"};